import React from 'react';

const AndroidInstructions = ({ onClose }) => {
  return (
    <div className="p-6 pt-0">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-8 h-8 text-green-600"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Contact downloaded successfully!
        </h3>
        <p className="text-gray-600">
          Follow these steps to import the contact to your phone:
        </p>
      </div>

      <div className="space-y-4 mb-6">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
            <span className="text-slate-600 text-sm font-semibold">1</span>
          </div>
          <p className="text-gray-700">
            Look at your phone's notification bar or pull down from the top
          </p>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
            <span className="text-slate-600 text-sm font-semibold">2</span>
          </div>
          <p className="text-gray-700">
            Tap on the downloaded file notification
          </p>
        </div>
        
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0 w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center">
            <span className="text-slate-600 text-sm font-semibold">3</span>
          </div>
          <p className="text-gray-700">
            Select "Contacts" or "Import to Contacts" when prompted
          </p>
        </div>
      </div>

      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <h4 className="font-semibold text-sm text-yellow-800 mb-1">Why this happens on Android</h4>
        <p className="text-sm text-yellow-800">
          For security and privacy, browsers on Android do not allow web pages to silently open other apps or import contacts without a direct user action. This prevents malicious websites from acting on your device without consent. If the contact did not open automatically, open the downloaded file from your notifications or Files app, or use the Share button to choose the Contacts app.
        </p>
      </div>

      <div className="text-center">
        <button
          onClick={onClose}
          className="bg-emerald-600 text-white px-6 py-4 w-full rounded-lg font-medium hover:bg-emerald-700 transition-colors"
        >
          Got it!
        </button>
      </div>
    </div>
  );
};

export default AndroidInstructions;
